// baseUrl.js

// export const BaseUrl = () => {
//     return  "https://apidev.sportsnerve.com/api/v1";
// };

// export const BaseUrl = () => {
//     return  "http://54.243.69.253:3000/api/v1";
// };

export const BaseUrl = () => {
    return "http://localhost:3000/api/v1";
}


// export const BaseUrl = () => {
//     return  "https://apps.sportsnerve.com";
// };
